module.exports = __webpack_public_path__ + "static/img/notext-starx.a2bface.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-starx.png
// module id = RQEC
// module chunks = 1